import { DivLabel, DivValue, DivWrap } from './style';

interface TotalGutterLengthLinearFtProps {
  totalGutterlengthLinearFt: number;
}

export default function TotalGutterLengthLinearFt({
	totalGutterlengthLinearFt,
}: TotalGutterLengthLinearFtProps) {
	return (
		<DivWrap className="roof-attr-wrap">
			<DivLabel className="roof-attr-label">
        Gutter Length <span>(linear ft)</span>:
			</DivLabel>
			<DivValue className="roof-attr-value">
				{totalGutterlengthLinearFt.toFixed(2)}
			</DivValue>
		</DivWrap>
	);
}
